<mat-card class="welcome-page-card">
    <h1 class="headline-h1">Welcome to the User Experience Portal</h1>
    <mat-divider></mat-divider>
    <mat-card-content class="mat-content">
      <jafar-manage-azure-widget></jafar-manage-azure-widget>
      <jafar-manage-cip-widget></jafar-manage-cip-widget>
    </mat-card-content>
</mat-card>
